import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

/** Shared translation loading policy for the application and integration tests. */
export function provideKubaTranslations() {
  return provideTranslateService({
    fallbackLang: 'en',
    loader: provideTranslateHttpLoader({
      prefix: 'assets/i18n/',
      suffix: '.json',
      failOnError: true,
      // The interceptor injects TranslateService; asset loading must not construct it recursively.
      useHttpBackend: true,
    }),
  });
}
